/* Orgville theme — cart, quick add, quick view, gifts, product page */
(() => {
  const O = window.Orgville || { routes: {}, gifts: [] };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (O.routes.root || '/').replace(/\/?$/, '/');
  const money = (paise) => {
    const r = paise / 100;
    return '₹' + r.toLocaleString('en-IN', { minimumFractionDigits: r % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  const giftVariants = (O.gifts || []).map((g) => Number(g.variant));
  const isGift = (item) => giftVariants.includes(Number(item.variant_id));

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { t.hidden = true; }, 2600);
  }

  /* ---------- Cart API ---------- */
  const json = (r) => { if (!r.ok) return r.json().then((e) => Promise.reject(e)); return r.json(); };
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(json);
  const getCart = () => fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(json);

  let busy = Promise.resolve();
  const queue = (fn) => (busy = busy.then(fn, fn));

  async function syncGifts(cart) {
    if (!giftVariants.length) return cart;
    const subtotal = cart.items.filter((i) => !isGift(i)).reduce((s, i) => s + i.final_line_price, 0) / 100;
    const updates = {};
    let needed = false;
    (O.gifts || []).forEach((g) => {
      const inCart = cart.items.filter((i) => Number(i.variant_id) === Number(g.variant)).reduce((s, i) => s + i.quantity, 0);
      const want = subtotal >= Number(g.threshold) ? 1 : 0;
      if (inCart !== want) { updates[g.variant] = want; needed = true; }
    });
    if (!needed) return cart;
    try {
      return await post(root + 'cart/update.js', { updates });
    } catch (e) {
      return cart;
    }
  }

  async function refresh(cart, opts = {}) {
    cart = await syncGifts(cart || (await getCart()));
    const count = cart.items.filter((i) => !isGift(i)).reduce((s, i) => s + i.quantity, 0);
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
    $$('[data-cart-count-text]').forEach((el) => { el.textContent = count; });
    $$('[data-cart-total]').forEach((el) => { el.textContent = money(cart.items_subtotal_price); });
    updateSizeStates(cart);
    try {
      const res = await fetch(root + '?sections=cart-drawer');
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('[data-cart-drawer]');
      const current = $('[data-cart-drawer]');
      if (fresh && current) {
        const wasOpen = !current.hidden;
        current.innerHTML = fresh.innerHTML;
        current.hidden = !wasOpen;
      }
      const freshBar = html.querySelector('[data-milestones]');
      $$('[data-milestones-slot]').forEach((slot) => { if (freshBar) slot.innerHTML = freshBar.outerHTML; });
    } catch (e) { /* drawer refresh is best-effort */ }
    if (opts.open) openDrawer();
    return cart;
  }

  function add(items, opts = {}) {
    return queue(async () => {
      try {
        await post(root + 'cart/add.js', { items });
        const cart = await refresh(null, opts);
        if (opts.message) toast(opts.message);
        return cart;
      } catch (e) {
        toast((e && (e.description || e.message)) || 'Sorry, that could not be added.');
      }
    });
  }

  function change(key, quantity) {
    return queue(async () => {
      try {
        const cart = await post(root + 'cart/change.js', { id: key, quantity });
        return refresh(cart);
      } catch (e) {
        toast((e && (e.description || e.message)) || 'Sorry, that could not be updated.');
      }
    });
  }

  /* ---------- Size buttons + steppers ---------- */
  let lastCart = null;
  function updateSizeStates(cart) {
    lastCart = cart;
    const qty = {};
    cart.items.forEach((i) => { if (!isGift(i)) qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity; });
    $$('[data-size]').forEach((el) => {
      const id = Number(el.dataset.size);
      const q = qty[id] || 0;
      el.classList.toggle('is-in-cart', q > 0);
      const stepper = $('[data-stepper]', el);
      if (stepper) { stepper.hidden = q === 0; const n = $('[data-qty]', stepper); if (n) n.textContent = q; }
    });
  }
  function lineKeyFor(variantId) {
    if (!lastCart) return null;
    const line = lastCart.items.find((i) => Number(i.variant_id) === Number(variantId) && !isGift(i));
    return line ? { key: line.key, quantity: line.quantity } : null;
  }

  /* ---------- Drawer ---------- */
  let lastFocus = null;
  function openDrawer() {
    const d = $('[data-cart-drawer]');
    if (!d) { window.location.href = O.routes.cart || '/cart'; return; }
    lastFocus = document.activeElement;
    d.hidden = false;
    document.body.style.overflow = 'hidden';
    const panel = $('.drawer__panel', d);
    if (panel) panel.focus();
  }
  function closeDrawer() {
    const d = $('[data-cart-drawer]');
    if (!d) return;
    d.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  /* ---------- Quick view ---------- */
  async function openQuickView(url) {
    const qv = $('#QuickView');
    if (!qv) { window.location.href = url; return; }
    const content = $('[data-quick-view-content]', qv);
    lastFocus = document.activeElement;
    content.innerHTML = '<p class="quick-view__loading">Loading…</p>';
    qv.hidden = false;
    document.body.style.overflow = 'hidden';
    try {
      const sep = url.includes('?') ? '&' : '?';
      const res = await fetch(url + sep + 'section_id=quick-view');
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      const inner = html.querySelector('.qv');
      content.innerHTML = inner ? inner.outerHTML : '<p class="quick-view__loading">Sorry, this product could not load.</p>';
      if (lastCart) updateSizeStates(lastCart);
      $('.quick-view__dialog', qv).focus();
    } catch (e) {
      window.location.href = url;
    }
  }
  function closeQuickView() {
    const qv = $('#QuickView');
    if (!qv || qv.hidden) return;
    qv.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  /* ---------- Global click handling ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target;

    const addBtn = t.closest('[data-add-variant]');
    if (addBtn) {
      e.preventDefault();
      const inQuick = addBtn.closest('[data-quick-shop], #QuickView, [data-cart-drawer]');
      const label = addBtn.dataset.sizeLabel ? ' ' + addBtn.dataset.sizeLabel : '';
      addBtn.classList.add('is-loading');
      add([{ id: Number(addBtn.dataset.addVariant), quantity: 1 }], {
        open: !inQuick,
        message: inQuick ? 'Added: ' + (addBtn.dataset.productTitle || 'item').split(' | ')[0] + label : null
      }).finally(() => addBtn.classList.remove('is-loading'));
      return;
    }

    const step = t.closest('[data-step]');
    if (step) {
      const sizeEl = step.closest('[data-size]');
      if (!sizeEl) return;
      const id = sizeEl.dataset.size;
      const line = lineKeyFor(id);
      const delta = Number(step.dataset.step);
      if (line) change(line.key, Math.max(0, line.quantity + delta));
      else if (delta > 0) add([{ id: Number(id), quantity: 1 }]);
      return;
    }

    const many = t.closest('[data-add-many]');
    if (many) {
      const items = many.dataset.addMany.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
      add(items, { open: true });
      return;
    }

    const reorder = t.closest('[data-reorder]');
    if (reorder) {
      const items = reorder.dataset.reorder.split(',').filter(Boolean).map((p) => { const [id, q] = p.split(':'); return { id: Number(id), quantity: Number(q) || 1 }; });
      if (items.length) add(items, { open: true });
      else toast('Items from your last order are not available right now.');
      return;
    }

    const lineBtn = t.closest('[data-line-change]');
    if (lineBtn) { change(lineBtn.dataset.lineChange, Number(lineBtn.dataset.qty)); return; }

    const qvBtn = t.closest('[data-quick-view]');
    if (qvBtn) { e.preventDefault(); openQuickView(qvBtn.dataset.quickView); return; }

    if (t.closest('[data-quick-view-close]')) { closeQuickView(); return; }
    if (t.closest('[data-cart-close]')) { closeDrawer(); return; }

    const opener = t.closest('[data-cart-open]');
    if (opener && $('[data-cart-drawer]') && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      refresh(lastCart).then(openDrawer);
      return;
    }

    const menuBtn = t.closest('[data-menu-toggle]');
    if (menuBtn) {
      const menu = $('#MobileMenu');
      const open = menu.hidden;
      menu.hidden = !open;
      menuBtn.setAttribute('aria-expanded', String(open));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeQuickView(); closeDrawer(); }
  });

  /* Cart attributes + note (gift options) */
  let noteTimer;
  document.addEventListener('change', (e) => {
    const attr = e.target.closest('[data-cart-attr]');
    if (attr) {
      post(root + 'cart/update.js', { attributes: { [attr.dataset.cartAttr]: attr.checked ? 'Yes' : '' } });
    }
    const filters = e.target.closest('[data-filters]');
    if (filters) {
      const params = new URLSearchParams(new FormData(filters));
      window.location.search = params.toString();
    }
  });
  document.addEventListener('input', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (note) {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(() => post(root + 'cart/update.js', { note: note.value }), 600);
    }
  });

  /* ---------- Quick Shop: search + active tab ---------- */
  function initQuickShop() {
    const qs = $('[data-quick-shop]');
    if (!qs) return;
    const input = $('[data-qs-search]', qs);
    if (input) {
      input.addEventListener('input', () => {
        const q = input.value.trim().toLowerCase();
        let shown = 0;
        $$('[data-qs-row]', qs).forEach((row) => {
          const match = !q || row.dataset.search.includes(q) || row.textContent.toLowerCase().includes(q);
          row.hidden = !match;
          if (match) shown++;
        });
        $$('[data-qs-sub]', qs).forEach((sub) => { sub.hidden = !$$('[data-qs-row]', sub).some((r) => !r.hidden); });
        $$('[data-qs-group]', qs).forEach((g) => { g.hidden = !$$('[data-qs-sub]', g).some((s) => !s.hidden); });
        const empty = $('[data-qs-empty]', qs);
        if (empty) empty.hidden = shown > 0;
      });
    }
    const tabs = $$('[data-qs-tab]', qs);
    if ('IntersectionObserver' in window && tabs.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            tabs.forEach((t) => t.classList.toggle('is-active', t.getAttribute('href') === '#' + en.target.id));
          }
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      $$('[data-qs-group]', qs).forEach((g) => io.observe(g));
    }
  }

  /* ---------- Product page ---------- */
  function gramsOf(title) {
    const m = String(title).match(/([\d.]+)\s*(kg|g)/i);
    if (!m) return null;
    return Number(m[1]) * (m[2].toLowerCase() === 'kg' ? 1000 : 1);
  }
  function initProduct() {
    const section = $('[data-product]');
    if (!section) return;
    const dataEl = $('[data-product-json]');
    const product = dataEl ? JSON.parse(dataEl.textContent) : null;
    const form = $('[data-product-form]', section);
    const idInput = $('[data-variant-id]', section);
    const priceEl = $('[data-price]', section);
    const unitEl = $('[data-unit-price]', section);
    const addBtn = $('[data-add-button]', section);
    const addLabel = $('[data-add-label]', section);

    const current = () => product && product.variants.find((v) => String(v.id) === String(idInput.value));
    function render(v) {
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      const g = gramsOf(v.title);
      if (unitEl) unitEl.textContent = g ? money(Math.round(v.price / g * 100)) + ' per 100 g' : '';
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      $$('[data-net-qty]').forEach((el) => { el.textContent = v.title; });
      $$('[data-mrp]').forEach((el) => { el.textContent = money(v.price); });
      $$('[data-sticky-price]').forEach((el) => { el.textContent = money(v.price); });
      $$('[data-sticky-variant]').forEach((el) => { el.textContent = v.title; });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    render(current());

    $$('[data-option]', section).forEach((input) => {
      input.addEventListener('change', () => {
        const values = $$('fieldset.pills', section).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
        const v = product.variants.find((variant) => variant.options.every((o, i) => o === values[i]));
        render(v);
      });
    });

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        add([{ id: Number(idInput.value), quantity: 1 }], { open: true }).finally(() => { if (addBtn) addBtn.disabled = !(current() || {}).available; });
      });
    }

    // Gallery
    $$('[data-thumb]', section).forEach((th) => {
      th.addEventListener('click', () => {
        const i = th.dataset.thumb;
        $$('[data-thumb]', section).forEach((x) => x.classList.toggle('is-active', x === th));
        $$('[data-slide]', section).forEach((s) => s.classList.toggle('is-active', s.dataset.slide === i));
      });
    });

    // Sticky add to cart
    const sticky = $('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; }).observe(addBtn);
      const sb = $('[data-sticky-add]', sticky);
      if (sb) sb.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }

    // Delivery estimate by PIN code
    const pin = $('[data-pin]', section);
    const check = $('[data-pin-check]', section);
    const result = $('[data-pin-result]', section);
    function estimate() {
      const p = (pin.value || '').trim();
      if (!/^\d{6}$/.test(p)) { result.textContent = 'Please enter a 6-digit PIN code.'; return; }
      const two = Number(p.slice(0, 2));
      let days, zone, free;
      const py = ['605', '609'].includes(p.slice(0, 3)) || p === '533464' || p === '673310';
      if ((two >= 60 && two <= 64) || py) { days = [2, 4]; zone = 'Tamil Nadu & Puducherry'; free = O.freeTn; }
      else if ((two >= 50 && two <= 53) || (two >= 56 && two <= 59) || (two >= 67 && two <= 69)) { days = [6, 9]; zone = 'South India'; free = O.freeRest; }
      else { days = [8, 12]; zone = 'your area'; free = O.freeRest; }
      const d = (k) => { const x = new Date(); x.setDate(x.getDate() + k); return x.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }); };
      result.textContent = 'Dispatches in 1–2 days. Arrives by ' + d(days[0]) + '–' + d(days[1]) + '. Free delivery to ' + zone + ' over ₹' + free + '.';
    }
    if (check) check.addEventListener('click', estimate);
    if (pin) pin.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); estimate(); } });
  }

  /* ---------- Lazy recommendation sections ---------- */
  async function hydrate(selector) {
    $$(selector).forEach(async (el) => {
      if (selector === '[data-pairs]' && !el.hasAttribute('data-fetch')) return;
      try {
        const res = await fetch(el.dataset.url);
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = html.querySelector(selector);
        if (!fresh) return;
        if (selector === '[data-pairs]') {
          const main = fresh.querySelector('.pairs__main');
          const wrap = el.querySelector('.pairs');
          if (main && wrap) wrap.prepend(main);
          return;
        }
        el.innerHTML = fresh.innerHTML;
      } catch (e) { /* optional */ }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initQuickShop();
    initProduct();
    hydrate('[data-pairs]');
    hydrate('[data-related]');
    getCart().then((cart) => refresh(cart)).catch(() => {});
  });
})();
